import normalize from "app/utils/normalize";
import { Platform } from "react-native";
import { textVariants } from "./TextVariants";

export const body = {
  ...textVariants,
  defaults: {
    ...Platform.select({
      ios: {
        fontFamily: "Inter",
      },
      web: {
        fontFamily: "Inter",
      },
      android: {
        fontFamily: "Inter-Regular",
      },
    }),
  },
  "l1-regular": {
    ...Platform.select({
      ios: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l1-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * 10,
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l1-semibold": {
    ...Platform.select({
      ios: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l1-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l2-regular": {
    ...Platform.select({
      ios: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Regular",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l2-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l2-semibold": {
    ...Platform.select({
      ios: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l2-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      android: {
        fontFamily: "Inter-Bold",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(10),
        fontSize: normalize(10),
      },
    }),
  },
  "l3-regular": {
    ...Platform.select({
      ios: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      android: {
        fontFamily: "Inter-Regular",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      web: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
    }),
  },
  "l3-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
    }),
  },
  "l3-semibold": {
    ...Platform.select({
      ios: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      web: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
    }),
  },
  "l3-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(12),
        fontSize: normalize(12),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * 20,
        fontSize: normalize(12),
      },
    }),
  },
  "l4-regular": {
    ...Platform.select({
      ios: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      android: {
        fontFamily: "Inter-Regular",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      web: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
    }),
  },
  "l4-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      android: {
        fontFamily: "Inter",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
    }),
  },
  "l4-semibold": {
    ...Platform.select({
      ios: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      web: {
        fontWeight: "600" as "600",
        lineHeight: normalize(14) * 1.4,
        fontSize: normalize(14),
      },
    }),
  },
  "l4-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      android: {
        fontFamily: "Inter-Bold",
        lineHeight: 1.4 * normalize(14),
        fontSize: normalize(14),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: normalize(14) * 1.4,
        fontSize: normalize(14),
      },
    }),
  },
  "l5-regular": {
    ...Platform.select({
      ios: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      android: {
        fontFamily: "Inter-Regular",
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      web: {
        fontWeight: "400" as "400",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
    }),
  },
  "l5-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      android: {
        fontFamily: "Inter",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
    }),
  },
  "l5-semibold": {
    ...Platform.select({
      ios: {
        fontWeight: "600" as "600",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      android: {
        fontFamily: "Inter-SemiBold",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      web: {
        fontWeight: "600" as "600",
        lineHeight: normalize(16) * 1.4,
        fontSize: normalize(16),
      },
    }),
  },
  "l5-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      android: {
        fontFamily: "Inter-Bold",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(16),
        fontSize: normalize(16),
      },
    }),
  },
  "l6-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
      android: {
        fontFamily: "Inter",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
    }),
  },
  "l6-bold": {
    ...Platform.select({
      ios: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
      android: {
        fontFamily: "Inter-Bold",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
      web: {
        fontWeight: "700" as "700",
        lineHeight: 1.4 * normalize(18),
        fontSize: normalize(18),
      },
    }),
  },
  "l8-medium": {
    ...Platform.select({
      ios: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(24),
        fontSize: normalize(24),
      },
      android: {
        fontFamily: "Inter-Medium",
        lineHeight: 1.4 * normalize(24),
        fontSize: normalize(24),
      },
      web: {
        fontWeight: "500" as "500",
        lineHeight: 1.4 * normalize(24),
        fontSize: normalize(24),
      },
    }),
  },
};
